/**
 * 画布缩放相关的常量定义
 */

export const CANVAS_CONTEXT_2D = '2d'
export const ERROR_GET_CONTEXT_FAILED = '获取画布上下文失败'